import { ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';
import { useSelector } from 'react-redux';
import { selectFilters, selectIsSuburban } from '../../../selectors/filters';
import { isStudio } from '../../../utils/roomsCount';

export function useGetObjectInfoTitle() {
  const { roomsCount, area, category, landArea, houseArea } = useSelector(selectFilters);
  const isSuburban = useSelector(selectIsSuburban);

  if (isSuburban) {
    return category === ESuburbanEstimationCategory.LandSale
      ? `Участок · ${landArea} сот.`
      : `Дом · ${houseArea} м² · ${landArea} сот.`;
  }

  const roomsCountText = isStudio(roomsCount as number) ? 'Студия' : `${roomsCount}-комн. квартира`;

  return `${roomsCountText} · ${area} м²`;
}
